import React from "react";
import "./BlogBrowser.css";

function BlogBrowser({ blog_url, blog_name }) {
  return (
    <div className="blogBrowser">
      <div className="container">
        <div className="row">
          <div className="column left">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
          <div className="column middle">
            <input type="text" value={blog_url} />
          </div>
          <div className="column right">
            <div style={{ float: "right" }}>
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </div>
          </div>
        </div>

        <div className="content">
          <iframe src={blog_url} title={blog_name}></iframe>
        </div>
      </div>
    </div>
  );
}

export default BlogBrowser;
